import $ from "jquery";

export default class Checkout {
    constructor() {
        this.addressSelect = document.querySelectorAll(".jsAddressSelect");
        this.provinceSelect = document.querySelector(".jsProvinceSelect");

        if (this.addressSelect.length > 0) {
            this.events();
        }
    }

    events() {
        window.addEventListener(
            "DOMContentLoaded",
            this.initializeSelectField.bind(this),
            {
                once: true,
            }
        );
        window.addEventListener(
            "DOMContentLoaded",
            this.initializeProvinceSelectField.bind(this),
            {
                once: true,
            }
        );

        jQuery(document).ready(function($) {
            jQuery("form.woocommerce-checkout").on('submit', function() {
             const clickedElement = document.querySelector(".checkout__buy-btn");
                        clickedElement.disabled = true;
                        const value = clickedElement.value;
                        clickedElement.innerText = "...";
                        clickedElement.style.opacity = "0.4";
        
                        setTimeout(() => {
                            clickedElement.disabled = false;
                            clickedElement.innerText = value;
                            clickedElement.style.opacity = "1";
                        }, 3500);
            });
        });
    }

    initializeProvinceSelectField() {
        const select = this.provinceSelect;

        $(select).select2({
            minimumResultsForSearch: -1,
        });
    }

    initializeSelectField() {
        const select = this.addressSelect;

        $(select).select2({
            minimumResultsForSearch: -1,
        });
    }
}
